// extracted by mini-css-extract-plugin
module.exports = {"PublishInformation__publish-information__1K-y_":"PublishInformation__publish-information__1K-y_","PublishInformation__icon__xmlb8":"PublishInformation__icon__xmlb8"};